import { pricing } from '@/pages/unauthenticated/pricing/components/constants';

import { TierCardBackgrounds } from './tier.card-backgrounds';
import { TierCardBorders } from './tier.card-borders';
import { TierFeatureRow } from './tier.feature-row';
import { TierFeatureTableHeadersSr } from './tier.feature-row-header.sr';
import { TierHeader } from './tier.header';

export const TierComparisonDesktop = () => {
  const { tiers, sections } = pricing;

  return (
    <section aria-labelledby="comparison-heading" className="hidden lg:block">
      <h2 id="comparison-heading" className="sr-only">
        Feature comparison
      </h2>

      <div className="relative">
        <div className="grid grid-cols-4 gap-x-8 border-t border-border before:block">
          {tiers.map((tier) => (
            <div key={tier.activeTier} aria-hidden="true" className="-mt-px">
              <TierHeader tier={tier} />
            </div>
          ))}
        </div>
      </div>

      <div className="-mt-6 space-y-16">
        {sections.map((section) => (
          <div key={section.name}>
            <h3 className="text-sm font-semibold leading-6">{section.name}</h3>
            <div className="relative -mx-8 mt-10">
              {/* Fake card backgrounds */}
              <TierCardBackgrounds />

              <table className="relative w-full border-separate border-spacing-x-8">
                <thead>
                  <TierFeatureTableHeadersSr tiers={tiers} />
                </thead>
                <tbody>
                  {section.features.map((feature, featureIdx) => (
                    <TierFeatureRow
                      feature={feature}
                      tiers={tiers}
                      key={featureIdx}
                      showBorder={featureIdx !== section.features.length - 1}
                    />
                  ))}
                </tbody>
              </table>

              {/* Fake card borders */}
              <TierCardBorders tiers={pricing.tiers} />
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};
